import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ErrorMessage = styled.span`
  font-size: 12px;
  color: ${ColorPalette.HEX.RedRYB};
`;
